module.exports = __webpack_public_path__ + "media/images/icons/icon-eye-68636b5d42f560d764252f5c993f7d2d.svg";